import { useState } from "react";
import { useCachedAssets } from "../../../../assets/hooks/use-cached-assets";
import { ContentLibraryEmptyModal } from "./content-library/content-library-empty-modal";
import { ContentLibraryLoadingErrorModal } from "./content-library/content-library-loading-error-modal";
import { ContentLibraryLoadingModal } from "./content-library/content-library-loading-modal";
import { ContentLibraryModal } from "./content-library/content-library-modal";

import type { NodeKey } from "lexical";
import type { FC } from "react";

export const AddImagesAndFilesModal: FC<{
  open: boolean;
  onClose: () => void;
  nodeKey?: NodeKey;
}> = ({ open, onClose, nodeKey }) => {
  const { data, loading, error, reload } = useCachedAssets();
  const [lastUploadFolderId, setLastUploadFolderId] = useState<string | null>(null);

  if (error) return <ContentLibraryLoadingErrorModal open={open} onClose={onClose} />;

  if (loading) return <ContentLibraryLoadingModal open={open} onClose={onClose} />;

  return data && data.length > 0 ? (
    <ContentLibraryModal
      open={open}
      onClose={onClose}
      assets={data}
      nodeKey={nodeKey}
      initialFolderId={lastUploadFolderId}
      onAssetUploaded={(folderId) => {
        if (folderId) setLastUploadFolderId(folderId);
        reload();
      }}
    />
  ) : (
    <ContentLibraryEmptyModal open={open} onClose={onClose} />
  );
};
